export const CardDetails = ({ payload }: any) => {
  const isCompany = payload?.property?.landlord?.landlordType === 'company';
  return ([
    {
      id: 1,
      attribute: [`${isCompany ? 'companyName' : 'landLordName'}`, 'landLordPhoneNumber', 'landLordEmail'],
      label: {
        [`${isCompany ? 'companyName' : 'landLordName'}`]: `${isCompany ? "Company's Name" : "Landlord's Name"}`,
        landLordPhoneNumber: 'Phone Number',
        landLordEmail: 'Interact Email Address',
      },
    },
    {
      id: 2,
      attribute: ['propertyAddress', 'unitNumber', 'rentAmount'],
      label: {
        propertyAddress: 'Property Address',
        unitNumber: 'Unit Number',
        rentAmount: 'Rent Amount',
      },
    },

    {
      id: 3,
      attribute: ['leaseFileDetails', '', ''],
      label: {
        leaseFileDetails: 'Lease Agreement',
      },
    },
  ]);
};
